import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Check } from "@mui/icons-material";
import React from "react";
export const Option = ({ label, onClick, selected = false }) => {
    const theme = useTheme();
    return (React.createElement(Box, { className: "variant-option", onClick: onClick, sx: {
            a: { textDecoration: "none" },
            alignItems: "center",
            borderColor: selected ? theme.palette.text.primary : theme.palette.divider,
            borderRadius: "4px",
            borderStyle: "solid",
            borderWidth: "1px",
            display: "flex",
            px: { xs: 2, xl: 3 },
            py: { xs: 1.5, lg: 2 },
            transition: theme.transitions.create(["border"]),
            "&:hover": {
                borderColor: theme.palette.text.primary,
                cursor: selected ? "default" : "pointer",
            },
        } },
        React.createElement(Stack, { alignItems: "center", direction: "row", spacing: { xs: 1, lg: 1.5 }, sx: { minHeight: "20px" } },
            selected && React.createElement(Check, { fontSize: "small", sx: { fontSize: "1.25rem" } }),
            React.createElement(Typography, { color: theme.palette.text.primary, component: "div", sx: { pt: 0, pb: 0 }, variant: "subtitle2" }, label))));
};
//# sourceMappingURL=option.js.map